import fecha from 'fecha';
import isEmpty from 'lodash/isEmpty';
import { firebaseListingTracker } from '../../Analytics/Firebase/util';
import {
  RAIL_LISTING_PAGE_DATA_TYPE,
  isLocusEmpty,
} from '../../PdtAnalytics/PdtHelper/RailsPdtUtils';
import fetch2, { Timeout } from '../../fetch2';
import { _label } from '../../vernacular/AppLanguage';
import { getFilterObject } from '../RailsFilters/RailsFilterActions';
import { createTicketTypeFilterObj } from '../RailsFilters/railsFilter.utils';
import QuotaType, { getQuota } from '../Types/QuotaType';
import * as actions from './RailsListingActions';
import railsConfig from 'apps/rails/src/RailsConfig';
import {
  fetchConfirmationGuaranteeOption,
  fetchFreeCancellationOption,
} from 'apps/rails/src/Utils/railofyUtils';
import { trackListingError } from '@mmt/legacy-commons/Common/utils/OmnitureTrackerUtils';
import { logGrafanaLatencyMetrics } from 'apps/rails/src/Utils/RailsGrafanaTracker';
import { ENTITY_TYPE, PAGE } from 'apps/rails/src/types/grafanaTracking.types';
import RAIL_EVENTS from 'apps/rails/src/RailsOmnitureTracker';
import {
  API_TIMEOUT,
  LISTING_CONNECTED_TRAVEL_EVENTS,
  LISTING_PAGE_TRACKING_KEY,
  LISTING_PAGE_TRACKING_KEY_V3,
  RAILS_DOWNTIME_CACHE,
  RESPONSE_FROM_CACHE,
  ODT_EVENTS,
  LISTING_DOWNTIME_ERROR_CODE,
  NEARBY_DATES_EVENTS,
  SCHEDULE_TATKAL_EVENTS,
} from 'apps/rails/src/Utils/RailsConstant';
import {
  COMMON_LATENCY,
  ENTITY,
  RAILS_LISTING_RETRY,
  availabilityBucketOmnitureMapping,
} from '../../Utils/RailsConstant';
import {
  calculateTtuExtent,
  isDynamicTrainInListing,
  removeTtuTrackingEvars,
} from '../../Utils/RailsOmnitureUtils';
import {
  updateEvar47or97Variable,
  removeEventFromEvar47or97Variable,
  trackConnectedEvar47or97Event,
  trackGenericEvar47or97Event,
  trackNewListingEvent,
  trackOdtEvar47or97Event,
  trackNewListingClickEvent,
} from '../../railsAnalytics';
import {
  getIfToShowRailsConnectedTravel,
  getRailsFcCalloutFlag,
  getOtherDayTrains,
  getShowRouteExtension,
  getRailsLDAndSSQuotaEnabled,
  getRailsTbsErrorHandlingFlowV1,
  getNearbyDatesVariants,
  getNearbyDatesNew,
} from '../../RailsAbConfig';
import { logGrafanaErrorMetrics } from '../../Utils/RailsGrafanaTracker';
import {
  getLocusIdFromStationDetails,
  setLocusData,
} from 'apps/rails/src/pages/RailsLandingPage/Store/RailsLandingPageActions';
import { logListingPageLoadEvent } from 'apps/rails/src/PdtAnalytics/PdtAnalyticsV2/PdtCtRailsListing';
import { buildEnrichedSearchContext } from 'apps/rails/src/PdtAnalytics/PdtAnalyticsV2/PdtV2Utils';
import { getRailsListingNewPdtLoggingOnOff } from 'apps/rails/src/RailsAbConfig';
import { getDataFromAsynStorage, RAILS_IS_PRE_FC_SELECTED } from 'apps/rails/src/Utils/RailsConstant';
import { showShortToast } from '@mmt/legacy-commons/Common/Components/Toast';
import {
  SCHEDULE_TATKAL_ACTIONS_LIST,
  loadScheduleTatkalBoardingStation,
  loadScheduleTatkalTravelerPreferences,
} from '../ScheduleTatkalTravelerPage/ScheduleTatkalTravelerPageActions';
import { Actions } from '../../navigation';
import { getScheduleTatkalDetails } from '../ScheduleTatkalTravelerPage/api/ScheduleTatkalApi';
import { GetScheduleTatkalDetailsRequest } from '../ScheduleTatkalTravelerPage/api/interface';
import { ACTION_INIT_SCHEDULE_TATKAL_TRAVELER, isValidIrctcUserName } from '../TravelerDetails/TravelerDetailsActions';
import { updateUsername } from '../User/UserVerification/UserVerificationActions';
import { getClassType } from '../Types/ClassType';
import { initServerTravelersMetaDataForScheduledTatkal } from '../ScheduleTatkalTravelerPage/utils/ScheduleTatkalTravelerUtils';
import { getMaxTravelersAllowedForBooking } from '../TravelerDetails/TravelerDetailsUtils';
import { loadRailsTravelers } from '../TravelerDetails/Containers/RailsTravelerRepository';

export const getMigratedTrainsList = (from, to, date) => async (dispatch, getState) => {
  dispatch({
    type: actions.ACTION_RAIL_LISTING_REMOVE_WEBVIEW,
    data: {
      showWebview: false,
    },
  });
      const {
        railsListing: { originStation, destinationStation, departureDate, fcStripIndex, stagedFilterObject },
        railsVernacular: { texts },
        railsLanding: { selectedClass, isFreeCancellationEnabled },
      } = getState();
  let showNoTrainView = false;
  let listingErrorCode = '';
  let listingErrorMessage = '';
  let listingErrorSubtitle = '';
  let recommendedDate = undefined;
  let recommendedList = [];
  let recommendedMessage = '';
  let noTrainFound = false;
  let otherDayTrainsList;
  let errorFlow = null;
  try {
    const ldAndSsQuotaEnabled = getRailsLDAndSSQuotaEnabled();
    const isTbsErrorHandlingFlowV1 = getRailsTbsErrorHandlingFlowV1();
    const overAllStart = performance.now();
    const { code: fromCode, stationName: fromStation } = from;
    const { code: toCode, stationName: toStation } = to;
    const deptDate = fecha.format(date, 'YYYYMMDD');
    const migratedSearchUrl = `${railsConfig.getTBSRailsListing}/${fromCode}/${toCode}/${deptDate}?class=${selectedClass}`;
    const migratedUrlWithParams = `${migratedSearchUrl}&source=${encodeURI(
      fromStation,
    )}&destination=${encodeURI(toStation)}${
      ldAndSsQuotaEnabled
        ? '&supportLadiesQuota=true&supportSeniorCitizenQuota=true&organization=MakeMyTrip'
        : ''
    }`;
    removeEventFromEvar47or97Variable(RAILS_LISTING_RETRY.RETRY_ON);
    removeEventFromEvar47or97Variable(RAILS_LISTING_RETRY.RETRY_OFF);
    dispatch({
      type: actions.ACTION_INIT_RAIL_LISTING,
    });
    const header = await actions.getRailsPostHeaders();
    const apiStart = performance.now();
    const res = await fetch2(migratedUrlWithParams, {
      headers: { ...header, organization: 'MMT' },
      signal: Timeout(API_TIMEOUT).signal,
    });
    let responseJson = await res.json();
    const { otherDayTrainsList: otherDayTrainsListVal } = responseJson;
    const isOtherDaytrains = getOtherDayTrains();
    if (isOtherDaytrains) {
      if (otherDayTrainsListVal?.length !== 0) {
        trackOdtEvar47or97Event(LISTING_PAGE_TRACKING_KEY, ODT_EVENTS.odt_shown);
      } else {
        trackOdtEvar47or97Event(LISTING_PAGE_TRACKING_KEY, ODT_EVENTS.odt_not_shown);
      }
    } else {
      trackOdtEvar47or97Event(LISTING_PAGE_TRACKING_KEY, ODT_EVENTS.odt_not_shown);
    }

    const isNewNearByDates = getNearbyDatesNew();
    const nearbyDatesVariant = getNearbyDatesVariants();

    if (isNewNearByDates) {
      removeEventFromEvar47or97Variable(NEARBY_DATES_EVENTS.nearByDatesVariant1);
      removeEventFromEvar47or97Variable(NEARBY_DATES_EVENTS.nearByDatesVariant2);
      removeEventFromEvar47or97Variable(NEARBY_DATES_EVENTS.nearByDatesVariant3);

      switch (nearbyDatesVariant) {
        case 2:
          trackGenericEvar47or97Event(
            LISTING_PAGE_TRACKING_KEY,
            NEARBY_DATES_EVENTS.nearByDatesVariant2,
          );
          break;
        case 3:
          trackGenericEvar47or97Event(
            LISTING_PAGE_TRACKING_KEY,
            NEARBY_DATES_EVENTS.nearByDatesVariant3,
          );
          break;
        default:
          trackGenericEvar47or97Event(
            LISTING_PAGE_TRACKING_KEY,
            NEARBY_DATES_EVENTS.nearByDatesVariant1,
          );
      }
    }

    if (!isOtherDaytrains) {
      responseJson['otherDayTrainsList'] = [];
    }
    if (responseJson?.responseFrom === RESPONSE_FROM_CACHE) {
      trackNewListingEvent(RAILS_DOWNTIME_CACHE);
    }
    const tbsApiTime = performance.now() - apiStart;
    logGrafanaLatencyMetrics(
      PAGE.LISTING_V3,
      ENTITY_TYPE.API,
      ENTITY.TBS_API,
      COMMON_LATENCY.TOTAL,
      tbsApiTime,
    );
    if (responseJson?.showBreakJourney) {
      dispatch(actions.getBreakJourneyList(from, to, date));
    }
    if (isEmpty(responseJson)) {
      trackListingError(
        RAIL_EVENTS.LISTING.MMT_RAIL_RN_LISTING,
        RAIL_EVENTS.LISTING.RAIL_LISTING_NULL_RESPONSE,
      );
      throw new Error('response json is null');
    }

    if (responseJson?.errorMessage) {
      trackListingError(
        RAIL_EVENTS.LISTING.MMT_RAIL_RN_LISTING,
        `${RAIL_EVENTS.LISTING.RAIL_LISTING_ERROR}${responseJson.errorMessage}`,
      );
      logGrafanaErrorMetrics(
        PAGE.LISTING_V3,
        ENTITY_TYPE.API,
        ENTITY.TBS_API,
        responseJson?.errorMessage,
        res.status,
      );
    }
    const { quotaList = {} } = responseJson;
    const cloneQuotaList = Array.from(quotaList);
    otherDayTrainsList = dispatch(
      actions.buildOtherDayTrainsList(responseJson?.otherDayTrainsList),
    );
    const otherDayTrainsListObject = otherDayTrainsList?.reduce((acc, item) => {
      const { avlClasses } = item;
      const selectedQuota = QuotaType.GN;
      const quotaClassRate = actions.getQuotaClassRate(cloneQuotaList, avlClasses);
      return {
        ...acc,
        [item.trainNumber]: {
          selectedQuota,
          quotaClassRate,
          selectedClassType: avlClasses[0],
          selectedDate: null,
          error: false,
          errorMessage: '',
          availabilityResponse: null,
          isLoading: false,
        },
      };
    }, {});
    if (responseJson.displayCovidForm && responseJson.covidFormLink) {
      dispatch({
        type: actions.ACTION_RAIL_LISTING_SHOW_WEBVIEW,
        data: {
          showWebview: true,
          webviewUrl: responseJson.covidFormLink,
          webviewHeader: responseJson.covidFormHeader || '',
          goBackUrl: responseJson.goBackUrl || '',
          from,
          to,
          deptDate,
        },
      });
      return;
    } else if (isEmpty(responseJson.trainBtwnStnsList)) {
      showNoTrainView = true;
      recommendedDate = responseJson.recommendedDate;
      noTrainFound = responseJson.noTrainFound;
      recommendedMessage = recommendedDate ? recommendedDate.recommendedMessage : '';
      recommendedList = recommendedDate ? recommendedDate.recommendedList : [];
      listingErrorCode = responseJson.errorDetails && responseJson.errorDetails.errorCode;
      listingErrorMessage = isEmpty(responseJson.errorMessage)
        ? responseJson.error
        : responseJson.errorMessage;

      if (isTbsErrorHandlingFlowV1) {
        trackGenericEvar47or97Event(LISTING_PAGE_TRACKING_KEY, RAILS_LISTING_RETRY.RETRY_ON);
      } else {
        trackGenericEvar47or97Event(LISTING_PAGE_TRACKING_KEY, RAILS_LISTING_RETRY.RETRY_OFF);
      }
      // TBS error handling V1 approach
      if (isTbsErrorHandlingFlowV1 && !isEmpty(responseJson?.errorFlow)) {
        errorFlow = responseJson.errorFlow;
      }

      dispatch({
        type: actions.ACTION_RAILS_LISTING_ERROR,
        data: {
          errorCode: listingErrorCode,
          errorMessage: listingErrorMessage,
          errorSubtitle: listingErrorSubtitle,
          errorFlag: true,
          recommendedMessage,
          recommendedList,
          noTrainFound,
          trainsList: [],
          minPriceDetails: {},
          minDuration: null,
          otherDayTrainsList,
          errorFlow,
        },
      });
      let listingErrorCodeString = null;
      const { railsLanding, railsListing } = getState();
      if (responseJson?.errorDetails?.errorCode === LISTING_DOWNTIME_ERROR_CODE) {
        listingErrorCodeString = 'IRCTC_SCHEDULED_DOWNTIME_WINDOW';
      }
      try {
        actions.trackPdtListingLoad(
          actions.getListingPagePdt(null, railsLanding, railsListing, null),
          RAIL_LISTING_PAGE_DATA_TYPE,
          listingErrorCodeString,
        );
      } catch (e) {
        console.error('error in tracking pdt listing load', e);
      }

      dispatch({
        type: actions.ACTION_UPDATE_QUOTA_SELECTED_OF_OTHER_DAY_TRAIN,
        data: otherDayTrainsListObject,
      });
    } else {
      const trainsList = dispatch(actions.buildTrainList(responseJson.trainBtwnStnsList));

      const { quotaList, showAlternateAvailability } = responseJson;
      const cloneQuotaList = Array.from(quotaList);
      const availableQuotaList = actions.getOrderedQuotaList(quotaList);
      const clientConfig = isEmpty(responseJson.clientConfig) ? null : responseJson.clientConfig;
      const minPriceDetails = responseJson?.minPriceDetails;
      const minDuration = responseJson?.minDuration;
      let alternateAvailabilityResponse = {};

      const showRouteExtensionFlag = getShowRouteExtension();
      removeEventFromEvar47or97Variable(`${RAIL_EVENTS.LISTING.RAIL_LISTING_ROUTE_EXTENSION_YES}`);
      removeEventFromEvar47or97Variable(`${RAIL_EVENTS.LISTING.RAIL_LISTING_ROUTE_EXTENSION_NO}`);
      if (showRouteExtensionFlag && responseJson.alternateAvailabilityList) {
        alternateAvailabilityResponse = {
          alternateAvailabilityList: responseJson.alternateAvailabilityList,
        };
        trackGenericEvar47or97Event(
          LISTING_PAGE_TRACKING_KEY,
          `${RAIL_EVENTS.LISTING.RAIL_LISTING_ROUTE_EXTENSION_YES}`,
        );
      } else {
        trackGenericEvar47or97Event(
          LISTING_PAGE_TRACKING_KEY,
          `${RAIL_EVENTS.LISTING.RAIL_LISTING_ROUTE_EXTENSION_NO}`,
        );
      }

      removeTtuTrackingEvars();
      const availabilityTracking =
        (responseJson?.availabilityBucket
          ? `${availabilityBucketOmnitureMapping?.[responseJson?.availabilityBucket]}|`
          : '') + calculateTtuExtent(trainsList);
      updateEvar47or97Variable(availabilityTracking);
      removeEventFromEvar47or97Variable(RAIL_EVENTS.LISTING.RAILS_DYNAMIC_PRICING);
      if (isDynamicTrainInListing(trainsList)) {
        updateEvar47or97Variable(RAIL_EVENTS.LISTING.RAILS_DYNAMIC_PRICING);
      }
      removeEventFromEvar47or97Variable(RAIL_EVENTS.LISTING.RAIL_LISTING_NEW_TBS_ERROR_ENABLED);
      removeEventFromEvar47or97Variable(RAIL_EVENTS.LISTING.RAIL_LISTING_NEW_TBS_ERROR_NOT_ENABLED);
      updateEvar47or97Variable(
        isTbsErrorHandlingFlowV1
          ? RAIL_EVENTS.LISTING.RAIL_LISTING_NEW_TBS_ERROR_ENABLED
          : RAIL_EVENTS.LISTING.RAIL_LISTING_NEW_TBS_ERROR_NOT_ENABLED,
      );
      dispatch({
        type: actions.ACTION_RAILS_LISTING_COMPLETE,
        data: {
          searchData: trainsList,
          availableQuotaList,
          selectedTrainInfo: null,
          showClassAvailability: false,
          clientConfig,
          showAlternateAvailability: !!showAlternateAvailability,
          minPriceDetails,
          minDuration,
          alternateAvailabilityResponse,
          covidSafetyCardData: responseJson?.safetyGuideLines ?? {},
          showBnpp: responseJson.showBnpp,
          doCacheAtClient: responseJson.doCacheAtClient,
          otherDayTrainsList,
          omnitureDetails: responseJson?.omnitureDetails,
          availabiltyBucket: responseJson?.availabilityBucket || '',
        },
      });
      dispatch({
        type: actions.ACTION_UPDATE_QUOTA_SELECTED_OF_OTHER_DAY_TRAIN,
        data: otherDayTrainsListObject,
      });
      let tbsRenderTime = performance.now() - overAllStart;
      tbsRenderTime = tbsRenderTime - tbsApiTime;
      logGrafanaLatencyMetrics(
        PAGE.LISTING_V3,
        ENTITY_TYPE.PAGE,
        COMMON_LATENCY.FIRST_RENDER,
        PAGE.LISTING_V2,
        tbsRenderTime,
      );

      const connectedTravelPokusVal = getIfToShowRailsConnectedTravel();
      let connectedTravelData = {};
      const showFcStamps = getRailsFcCalloutFlag();
      if (connectedTravelPokusVal) {
        if (responseJson?.callForCt) {
          connectedTravelData = await dispatch(
            actions.setConnectedTravelData(fromCode, toCode, date),
          );
        } else {
          removeEventFromEvar47or97Variable(LISTING_CONNECTED_TRAVEL_EVENTS.connectedNotShown);
          removeEventFromEvar47or97Variable(LISTING_CONNECTED_TRAVEL_EVENTS.connectedShown);
        }
      } else {
        trackConnectedEvar47or97Event(
          LISTING_PAGE_TRACKING_KEY,
          LISTING_CONNECTED_TRAVEL_EVENTS.connectedNotShown,
        );
      }

      const trainsListObject = trainsList.reduce((acc, item) => {
        const { avlClasses } = item || {};
        const selectedQuota = QuotaType.GN;
        const quotaClassRate = actions.getQuotaClassRate(cloneQuotaList, avlClasses);
        return {
          ...acc,
          [item.trainNumber]: {
            selectedQuota,
            quotaClassRate,
            selectedClassType: avlClasses?.length > 0 ? avlClasses[0] : null,
            selectedDate: null,
            error: false,
            errorMessage: '',
            availabilityResponse: null,
            isLoading: false,
          },
        };
      }, {});

      dispatch({
        type: actions.ACTION_UPDATE_QUOTA_SELECTED_OF_TRAIN,
        data: trainsListObject,
      });

      dispatch({
        type: actions.ACTION_UPDATE_QUOTA_SELECTED_OF_OTHER_DAY_TRAIN,
        data: otherDayTrainsListObject,
      });
      const filterObject = getFilterObject(trainsList, from, to, texts, getState);
      dispatch({
        type: actions.ACTION_INIT_RAILS_LISTING_FILTERS,
        data: { filterObject },
      });
      firebaseListingTracker({ originStation, destinationStation, departureDate });
      //TODO:: Include updateFilters in getFilterObject
      dispatch(updateFilters(trainsList));
      dispatch(saveFGTG());
      const { railsLanding, railsListing } = getState();
      actions.trackPdtListingLoad(
        actions.getListingPagePdt(trainsList, railsLanding, railsListing, null),
        RAIL_LISTING_PAGE_DATA_TYPE,
        null,
      );

      // const { isFreeCancellationEnabled } = railsLanding;
      // const { fcStripIndex } = railsListing;
      const fcFromStorage = await getDataFromAsynStorage(RAILS_IS_PRE_FC_SELECTED);
      const finalFcEnabled = isFreeCancellationEnabled || fcFromStorage || false;
      const fcInterventionData = {
        isFreeCancellationEnabled: finalFcEnabled,
        fcStripIndex,
      };
      const locusDetails = railsLanding?.LocusDetails;
      if (isLocusEmpty(locusDetails)) {
        try {
          const locusDetail = await getLocusIdFromStationDetails({
            from_station_code: originStation?.code,
            to_station_code: destinationStation?.code,
          });
          dispatch(setLocusData(locusDetail));
        } catch (error) {
        }
      }

      const searchContext = await buildEnrichedSearchContext(getState());

      const logNewMeasurementPlatformPdt = getRailsListingNewPdtLoggingOnOff();

      if (logNewMeasurementPlatformPdt) {
        logListingPageLoadEvent(
          'LISTING_LOAD',
          trainsList,
          connectedTravelData,
          fcInterventionData,
          searchContext,
          stagedFilterObject,
        );
      }
      dispatch(actions.toggleNearbyDatesList(false, '', '', ''));
      dispatch({
        type: actions.ACTION_INT_NEARBY_DATES_LIST,
        data: {},
      });
      trackGenericEvar47or97Event(LISTING_PAGE_TRACKING_KEY, `fc${showFcStamps ? 'yes' : 'no'}`);
      const overAllTime = performance.now() - overAllStart;
      logGrafanaLatencyMetrics(
        PAGE.LISTING_V3,
        ENTITY_TYPE.PAGE,
        COMMON_LATENCY.OVERALL_RENDER,
        PAGE.LISTING_V2,
        overAllTime,
      );
      logGrafanaLatencyMetrics(
        PAGE.LISTING_V3,
        ENTITY_TYPE.API,
        'listing_all_api',
        COMMON_LATENCY.TOTAL,
        tbsApiTime,
      );
    }
  } catch (error) {
    trackListingError(
      RAIL_EVENTS.LISTING.MMT_RAIL_RN_LISTING,
      RAIL_EVENTS.LISTING.RAIL_LISTING_SOMETHING_WRONG,
    );
    showNoTrainView = true;
    let errorCodeLatest = error?.errorCode || listingErrorCode;
    listingErrorMessage = _label('something_went_wrong');
    listingErrorSubtitle = `${_label(
      'please_try_again_after_some_time',
    )} Error Code: ${errorCodeLatest}`;
    logGrafanaErrorMetrics(PAGE.LISTING_V3, ENTITY_TYPE.API, ENTITY.TBS_API, error?.message, 3200);
    const { code: fromCode, stationName: fromStation } = from || {};
    const { code: toCode, stationName: toStation } = to || {};
    const errorData = {
      listingV3: true,
      catchedErrorMesage: error?.message,
      railsFromCode: fromCode,
      railsFromStation: fromStation,
      railsToCode: toCode,
      railsToStation: toStation,
      railsRawDeptDate: date,
    };
    actions.logErrorToFirebase(errorData);
  }
  if (showNoTrainView) {
    dispatch({
      type: actions.ACTION_RAILS_LISTING_ERROR,
      data: {
        errorCode: listingErrorCode,
        errorMessage: listingErrorMessage,
        errorSubtitle: listingErrorSubtitle,
        errorFlag: true,
        recommendedMessage,
        recommendedList,
        noTrainFound,
        trainsList: [],
        minPriceDetails: {},
        minDuration: null,
        otherDayTrainsList,
        errorFlow,
      },
    });
    try {
      dispatch(actions.connectedTravellerforDeadEnds(from, to, date, listingErrorCode));
    } catch (error) {
      console.error('error in fetching connected travellers for dead end', error);
    }
  }
};

export const updateFilters = (trainsList: any[]) => async (dispatch: any, getState: any) => {
  try {
    if (!isEmpty(trainsList)) {
      const { filterObject = {} } = getState().railsListing;
      let noOfConfirmationGuaranteeTrains = 0;
      let noOfFreeCancellationTrains = 0;
      trainsList.forEach(({ tbsAvailability }) => {
        tbsAvailability.forEach(({ confirmationGuaranteeText, freeCancellationText }) => {
          if (confirmationGuaranteeText) {
            noOfConfirmationGuaranteeTrains += 1;
          } else if (freeCancellationText) {
            noOfFreeCancellationTrains += 1;
          }
        });
      });
      const ticketTypeFilter = createTicketTypeFilterObj(
        noOfConfirmationGuaranteeTrains,
        noOfFreeCancellationTrains,
      );
      dispatch({
        type: actions.ACTION_INIT_RAILS_LISTING_FILTERS,
        data: {
          filterObject: {
            ...filterObject,
            ticketTypeFilter,
          },
        },
      });
    }
  } catch (e) {}
};

export const saveFGTG = () => async (dispatch: any, getState: any) => {
  const railsConfirmationGuaranteeOption = await fetchConfirmationGuaranteeOption();
  const freeCancellationEnabled = await fetchFreeCancellationOption();
  dispatch(actions.saveConfirmationGuaranteeConfig(railsConfirmationGuaranteeOption));
  dispatch(actions.saveFreeCancellationConfig(freeCancellationEnabled));
};

export const toggleScheduleTatakalBottomSheet =
  (val: boolean = false) =>
  async (dispatch: any) => {
  dispatch({
      type: actions.ACTION_PREFILL_DATA_FOR_POPUP,
    data: {
        displayScheduleTatkalBottomSheet: val,
      },
    });
    if (!val) {
      trackNewListingClickEvent(SCHEDULE_TATKAL_EVENTS.listingScheduleTatkalBsCrossClick);
    }
};

export const onScheduleTatkalCardClick =
  (availabilityItem: any, trainData: any) => async (dispatch: any, getState: any) => {
    try {
      const payload: GetScheduleTatkalDetailsRequest = {
        source: trainData?.frmStnCode,
        destination: trainData?.toStnCode,
        doj: fecha.format(trainData?.departureDateAndTime, 'YYYYMMDD') || '',
        classType: availabilityItem?.classType || availabilityItem?.className || '',
        trainNumber: trainData?.trainNumber,
      };
      const res = await getScheduleTatkalDetails(payload);

      if (res?.error || res?.errorMessage) {
        showShortToast(_label(res?.errorMessage || 'something_went_wrong'));
        return;
      }
      dispatch(toggleScheduleTatakalBottomSheet(true));
      // success response
      if (res?.formId) {
        const contactDetails = {
          mobile: res?.mobileNumber,
          email: res?.email,
          hasCompleteFields: true,
        }
        dispatch({
          type: SCHEDULE_TATKAL_ACTIONS_LIST.ACTION_SCHEDULE_TATKAL_CARD_CLICK,
          data: {
            selectedTrainInfo: {
              ...trainData,
              ...(!isEmpty(res?.boardingStation) && {
                boardingStation: {
                  code: res?.boardingStation,
                },
              }),
            },
            selectedClassType: availabilityItem?.classType || availabilityItem?.className || '',
            bkgCfg: res?.bkgCfg || {},
            scheduleTatkalFormDetails: res,
            contactDetails,
            optionalGstDetailsEnabled: false,
            ...(!isEmpty(res?.gstDetails) && { optionalGstDetailsEnabled: true }),
            gstDetails: res?.gstDetails || { nameOnGst: '', gstIn: '' },
          },
        });
        dispatch(loadScheduleTatkalBoardingStation(res?.boardingStation));
        // prefill irctc username if valid
        dispatch(updateUsername(null));
        if (res?.irctcUserId) {
          const { railsTraveler: { selectedQuota = null } = {} } = getState() || {};
          const headers = {
            quota: selectedQuota?.code,
          };
          const isValidUserName = await isValidIrctcUserName(res?.irctcUserId, headers);
          if (isValidUserName) {
            dispatch(updateUsername(res?.irctcUserId));
          }
        }
      } else {
        dispatch({
          type: SCHEDULE_TATKAL_ACTIONS_LIST.ACTION_SCHEDULE_TATKAL_CARD_CLICK,
          data: {
            selectedTrainInfo: trainData,
            selectedClassType: availabilityItem?.classType || availabilityItem?.className || '',
            bkgCfg: res?.bkgCfg || {},
            scheduleTatkalFormDetails: res,
          },
        });
        dispatch(loadScheduleTatkalBoardingStation());
      }
      const dispatchData = {
        ...(res?.bkgCfg || {}),
        applicableFoodTypes: res?.bkgCfg?.applicableFoodTypes || {},
      };
      dispatch({
        type: actions.ACTION_BJ_SET_DATA_FOR_TRAVELERS_PAGE,
        data: dispatchData,
      });
      const config = {
        applicableBerthTypes: res?.bkgCfg?.applicableBerthTypes || [],
        foodChoiceEnabled: res?.bkgCfg?.foodChoiceEnabled === 'true' || false,
        selectedQuota: getQuota('TQ'),
        classValue: getClassType(res?.journeyDetails?.journeyClass),
        seniorCitizenApplicable: res?.bkgCfg?.seniorCitizenApplicable === 'true' || false,
        applicableFoodTypes: res?.bkgCfg?.applicableFoodTypes || {},
      };
      let showViewAll = false;
      let { travelers = [], selectedTravelers = [] } =
        initServerTravelersMetaDataForScheduledTatkal(res?.passengerList || [], config);
      const maxTravelersAllowed = getMaxTravelersAllowedForBooking(getQuota('TQ'));
      if (!res?.formId) {
        const { railsTraveler = {} } = getState();
        travelers = (await loadRailsTravelers(railsTraveler, getState, dispatch)) || [];
        selectedTravelers = [];
        showViewAll = travelers?.length > 3;
      }
      const travelerDispatchData = {
        ...(res?.bkgCfg || {}),
        selectedQuota: getQuota('TQ'),
        travelers,
        selectedTravelers,
        showViewAll,
        optionalGstDetailsEnabled: false,
        ...(!isEmpty(res?.gstDetails) && { optionalGstDetailsEnabled: true }),
        gstDetails: res?.gstDetails || { nameOnGst: '', gstIn: '' },
        maxTravelersAllowed,
      }
      dispatch({
        type: ACTION_INIT_SCHEDULE_TATKAL_TRAVELER,
        data: travelerDispatchData,
      });
      dispatch(loadScheduleTatkalTravelerPreferences(config));
    } catch (e: any) {
      console.log('Error on click of scheduleTatkalCardClick', e);
    }
  };

export const openScheduleTatkalTravelerPage = () => () => {
  Actions.openScheduleTatkalTravelerPage();
};
